import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap } from "lucide-react";
import Button from "../common/Button";

const StartTechcareer = () => {
  const imageUrl =
    "https://plus.unsplash.com/premium_photo-1723780879636-867cc32bbcfd?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

  return (
    <section className="cht-py-14 sm:cht-py-20 cht-bg-[#f8fafc]/70 cht-border-y cht-border-slate-200/80 !cht-font-body">
      <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8">
        <div className="cht-grid lg:cht-grid-cols-12 cht-gap-10 lg:cht-gap-12 cht-items-center">
          {/* Text Content (6 cols) */}
          <div className="lg:cht-col-span-6 cht-space-y-5 cht-text-left">
            <div className="cht-inline-flex cht-items-center cht-gap-2 cht-px-3.5 cht-py-1.5 cht-bg-blue-50 cht-border cht-border-blue-100 cht-rounded-full cht-text-xs !cht-font-bold cht-text-[#3e57da]">
              <GraduationCap size={15} />
              <span>Career Acceleration Programs</span>
            </div>

            <h2 className="!cht-font-heading cht-text-2xl sm:cht-text-4xl lg:cht-text-5xl !cht-font-extrabold cht-text-[#1e293b] cht-tracking-tight !cht-leading-[1.18]">
              Elevate Your Career with{" "}
              <span className="cht-text-[#3e57da]">Expert-Led Programs</span>
            </h2>

            {/* Mobile Image preview */}
            <div className="lg:cht-hidden cht-my-4">
              <div className="cht-rounded-[22px] cht-border cht-border-slate-200/80 cht-shadow-soft cht-overflow-hidden">
                <img
                  src={imageUrl}
                  alt="Students learning at Codehub Technologies"
                  className="cht-w-full cht-h-auto cht-object-cover"
                />
              </div>
            </div>

            <p className="!cht-font-body cht-text-sm sm:cht-text-base md:cht-text-lg cht-text-slate-600 cht-leading-relaxed">
              Master in-demand software skills, learn directly from industry
              leaders through practical capstone projects, and join an elite
              engineering ecosystem. Start your professional transformation
              today!
            </p>

            <div className="cht-pt-2 cht-flex cht-flex-wrap cht-items-center cht-gap-3">
              <Button
                to="/courses"
                variant="primary"
                size="md"
                rightIcon={<ArrowRight size={15} />}
              >
                Browse All Courses
              </Button>
            </div>
          </div>

          {/* Desktop Showcase Image (6 cols) */}
          <div className="cht-hidden lg:cht-block lg:cht-col-span-6">
            <div className="cht-relative cht-rounded-[24px] cht-border cht-border-slate-200/80 cht-shadow-float cht-overflow-hidden cht-bg-white group">
              <img
                src={imageUrl}
                alt="Students collaborating at Codehub Technologies"
                className="cht-w-full cht-h-full cht-object-cover cht-transition-transform cht-duration-700 group-hover:cht-scale-[1.03]"
                loading="lazy"
              />
              <div className="cht-absolute cht-bottom-4 cht-left-4 cht-right-4 cht-p-4 cht-bg-white/90 cht-backdrop-blur-md cht-border cht-border-white/50 cht-rounded-2xl cht-shadow-sm">
                <div className="cht-flex cht-items-center cht-gap-2 cht-text-xs !cht-font-bold cht-text-[#3e57da]">
                  <span>Accredited Practical Learning</span>
                </div>
                <p className="cht-text-xs cht-text-slate-600 cht-mb-0 cht-mt-1">
                  Hands-on curriculum, dedicated mentoring, and verified
                  certifications.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartTechcareer;
